// extracted by mini-css-extract-plugin
module.exports = {"title":"newsletter-success-message_title__hU5P3","text":"newsletter-success-message_text__J_nRn"};